import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import registerServiceWorker from './registerServiceWorker'
import './index.css'

// REDUX initialization
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
// import logger from 'redux-logger'
import eventmapReducers from './components/actionsReducers'

let globalEventmapStore
if (process.env.NODE_ENV === 'production') {
  globalEventmapStore = createStore(eventmapReducers, compose(applyMiddleware(thunkMiddleware)))
} else {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  // globalEventmapStore = createStore(eventmapReducers, composeEnhancers(applyMiddleware(thunkMiddleware, logger)))
  globalEventmapStore = createStore(eventmapReducers, composeEnhancers(applyMiddleware(thunkMiddleware)))
}

ReactDOM.render(
  <Provider store={globalEventmapStore}>
    <App />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js